// Central source of truth for all marketing/UI counts.
// Everything here is derived from the generated symbol index and curated
// block/script data — never hardcoded.
import { categories } from "./symbols";
import { TOTAL_SYMBOLS } from "./symbol-name-map.generated";
import { blocks } from "./unicode-blocks";

export const totalSymbols = TOTAL_SYMBOLS;
export const totalCategories = categories.length;
export const totalBlocks = blocks.length;

/** Locale-formatted count, e.g. 1234 → "1,234". */
export function formatCount(n: number): string {
  return n.toLocaleString("en-US");
}

/**
 * "At-least" marketing count — rounds DOWN to a friendly bucket and adds "+".
 * Buckets scale with size so 456 → "450+", 1234 → "1,200+", 12_345 → "12,000+".
 */
export function formatCountPlus(n: number): string {
  if (n < 10) return `${n}`;
  const magnitude = Math.pow(10, Math.floor(Math.log10(n)) - 1);
  const bucket = Math.floor(n / magnitude) * magnitude;
  return `${formatCount(bucket)}+`;
}
